import t from 'tcomb';

const Register_Country = t.enums.of(['AT', 'BR', 'CA', 'CH', 'DE', 'ES', 'FR', 'GB', 'IT', 'US', 'ZA']);

module.exports = Register_Country;


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Register_Country.js
 **/